import React, { useState } from 'react';
import { toast } from 'sonner';
import { useStore } from '../../contexts/StoreContext';
import { Field } from '../ui/Field';
import { isValidEmail, isValidPhone, normalizePhone } from '../../utils/validation';
export function SettingsPanel() {
  const {
    settings,
    updateSettings,
    resetData
  } = useStore();
  const [whatsapp, setWhatsapp] = useState(settings.whatsapp);
  const [logoUrl, setLogoUrl] = useState(settings.logoUrl);
  const [email, setEmail] = useState(settings.companyEmail);
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const save = (e: React.FormEvent) => {
    e.preventDefault();
    if (whatsapp && !isValidPhone(whatsapp)) return setError('El WhatsApp debe incluir código de país y área (ej.: 5491155555555).');
    if (logoUrl && !/^https:\/\//.test(logoUrl)) return setError('El logo debe ser una URL https.');
    if (email && !isValidEmail(email)) return setError('Email inválido.');
    if (pin && pin.length < 6) return setError('La clave debe tener al menos 6 caracteres.');
    setError('');
    updateSettings({
      whatsapp: whatsapp ? normalizePhone(whatsapp) : '',
      logoUrl,
      companyEmail: email,
      ...(pin ? {
        adminPin: pin
      } : {})
    });
    setPin('');
    toast.success('Ajustes guardados');
  };
  return <div className="grid gap-10 lg:grid-cols-[1fr_320px]" data-id="element-216" data-mp="27ja5hgb5sm7p">
      <form onSubmit={save} className="max-w-xl space-y-4" noValidate data-id="element-217" data-mp="27iqlzv5v1prk">
        <Field label="WhatsApp comercial" htmlFor="st-wa" hint="Con código de país, sin + ni espacios. Ej.: 5491155555555" data-id="element-218" data-mp="22kp7zonakgmy">
          <input id="st-wa" className="input" inputMode="tel" value={whatsapp} onChange={e => setWhatsapp(e.target.value)} data-id="element-219" data-mp="1xrvzcpopco5l" />
        </Field>
        <Field label="Logo oficial de VCARS (URL https)" htmlFor="st-logo" hint="Se muestra tal cual, sin modificaciones. Si está vacío se usa el logotipo provisorio." data-id="element-220" data-mp="1nvjaq680l0hp">
          <input id="st-logo" className="input" value={logoUrl} onChange={e => setLogoUrl(e.target.value)} data-id="element-221" data-mp="1jv8ttyioopo2" />
        </Field>
        {logoUrl && /^https:\/\//.test(logoUrl) && <div className="rounded-xl border border-line bg-panel p-4" data-id="element-222" data-mp="155fl2kw40qk5">
            <img src={logoUrl} alt="Vista previa del logo" className="h-10 w-auto" data-id="element-223" data-mp="199dgolm87j8g" />
          </div>}
        <Field label="Email comercial" htmlFor="st-email" data-id="element-224" data-mp="v9uleteik2dk">
          <input id="st-email" type="email" className="input" value={email} onChange={e => setEmail(e.target.value)} data-id="element-225" data-mp="107e4c6m5p3bu" />
        </Field>
        <Field label="Nueva clave del panel" htmlFor="st-pin" hint="Dejá vacío para mantener la actual." data-id="element-226" data-mp="1nyjec55f11e8">
          <input id="st-pin" type="password" className="input" value={pin} onChange={e => setPin(e.target.value)} autoComplete="new-password" data-id="element-227" data-mp="1svs0shxljrla" />
        </Field>
        {error && <p className="text-sm text-danger" role="alert" data-id="element-228" data-mp="1j5qadjhrtx37">{error}</p>}
        <button type="submit" className="btn btn-primary" data-id="element-229" data-mp="26w2tzrmdpi9m">Guardar ajustes</button>
      </form>
      <div className="space-y-4" data-id="element-230" data-mp="26u9mka3xyu0k">
        <div className="rounded-2xl border border-line p-5 text-sm text-mist" data-id="element-231" data-mp="2bn2nemwahi7d">
          <h3 className="font-semibold text-white" data-id="element-232" data-mp="7kbygd2z96s">Almacenamiento</h3>
          <p className="mt-2" data-id="element-233" data-mp="5pnis2loyxy">
            En esta versión los datos se guardan en el navegador de este dispositivo. Para operar en producción con múltiples asesores, conectá una base de datos
            con autenticación (por ejemplo Supabase) y reemplazá la capa de datos.
          </p>
        </div>
        <div className="rounded-2xl border border-danger/30 p-5" data-id="element-234" data-mp="50wm5lh0jdg0">
          <h3 className="font-semibold" data-id="element-235" data-mp="3df5c0ls5hq4h">Restablecer datos de demostración</h3>
          <p className="mt-2 text-sm text-mist" data-id="element-236" data-mp="38g0xdfmgj06r">Borra consultas, historial y cambios, y vuelve al catálogo inicial.</p>
          <button onClick={() => {
          if (window.confirm('¿Restablecer todos los datos? Esta acción no se puede deshacer.')) {
            resetData();
            toast.success('Datos restablecidos');
          }
        }} className="btn btn-danger mt-4 w-full" data-id="element-237" data-mp="3mftqfhlghshw">
            Restablecer
          </button>
        </div>
      </div>
    </div>;
}